<template id="different">
  <div class="outer-container">
    <div class="container">
      <h2 class="text-center header-font">
        How will it Pay you
      </h2>

      <div class="grid">
        <div class="flexing">
          <h2 class="manrope">01</h2>

          <h3>
            Take the quiz
          </h3>
          <a
            href="https://quiz.upskill.com.bd/assessment/e5482c3e-5c92-45ff-b375-dc63884f223c?public=true"
          >
            <button class="btn-1" disabled>
              Take the Quiz
            </button>
          </a>
        </div>

        <div class="flexing">
          <h2 class="manrope">02</h2>

          <h3>
            Do the online lessons every week
          </h3>
        </div>

        <div class="flexing">
          <h2 class="manrope">03</h2>

          <h3>
            Attend live workshops every Saturday with the Instructor
          </h3>
        </div>

        <div class="flexing">
          <h2 class="manrope">04</h2>

          <h3>
            Complete all the projects
          </h3>
        </div>
        <div class="flexing">
          <h2 class="manrope">05</h2>

          <h3>
            Get certified
          </h3>
        </div>
        <div class="flexing">
          <h2 class="manrope">06</h2>

          <h3>
            Proceed to interview
          </h3>
        </div>

        <div class="flexing">
          <h2 class="manrope">07</h2>

          <h3>
            Get hired at Bongo!
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.btn-1 {
  background-color: #2465f3;

  max-width: 100px;
  min-width: 158px;
  min-height: 50px;
  border: none;
  color: white;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 4px;
}

/* Darker background on mouse-over */
.btn-1:hover {
  background-color: #2465f3;
}
.manrope {
  font-family: 'Manrope';
  font-size: 54px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #ff636b;
  padding-left: 20px;
}
.outer-container {
  background-color: #ececec;
  margin-top: 100px;
}
.header-font {
  padding-top: 100px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
}

.grid {
  padding-top: 60px;
  display: grid;

  grid-template-columns: repeat(7, 1fr);
  grid-gap: 10px;
  max-width: 1300px;
  margin: 0 auto;
}
.grid h3 {
  padding: 40px;
  font-family: 'Manrope';
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #d21e28;

  padding-left: 20px;
}
.border-bottom h2 {
  border-bottom: 1px solid white;
  padding-bottom: 15px;
}
.grid h4 {
  text-transform: uppercase;
  font-family: 'Open Sans';
  font-size: 60px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 24px;
  color: #ffffff;
}
.flexing {
  min-height: 300px;
}
.flexing img {
  padding-top: 30px;
  padding-left: 20px;
}
.flex {
  display: inline-flex;
}
.flex .left {
  margin-right: 20px;
}
@media only screen and (max-width: 600px) {
  .grid {
    padding-top: 60px;
    display: grid;

    grid-template-columns: repeat(1, 1fr);
    grid-gap: 50px;
    max-width: 1300px;
    margin: 0 auto;
    padding-bottom: 100px;
  }
  .flexing {
    min-height: unset;
  }
}
</style>
